(ns dre.components.searchbar.filters
  (:require
   [dre.components.button :refer [button]]
   [dre.components.icon :refer [fa-icon]]
   [dre.components.pill :refer [pills] :rename {pills pills-component}]
   [dre.utils.bem :as bem-utils]))

(def ^:private component-name :searchbar-filters)

(defn- be
  [e]
  (bem-utils/be component-name e))

(defn- reset
  [{:keys [on-filter-reset]}]
  [button
   {:size :small
    :on-click on-filter-reset}
   [:<>
    [fa-icon :x-mark]
    "Reset"]])

(defn- promote
  [{:keys [on-filter-promote]}]
  [button
   {:size :small
    :on-click on-filter-promote}
   [:<> 
    [fa-icon :angles-up]
    "Promote"]])

(defn filters
  "Renders filter-query with pills component including reset and promote buttons."
  [opts]
  (let [{:keys [filter-query] :as opts} (update opts :filter-query
                                                #(when (some? %)
                                                   (deref %)))]
    (when (seq (:query/pills filter-query))
      [:div
       {:class component-name}
       [:div
        {:class (be :pills)}
        [pills-component (:query/pills filter-query)]]
       [:div
        {:class (be :action-buttons)}
        [reset opts]
        [promote opts]]])))
